/* ============================================================
   WESTON COUTURE — Sticky Add to Cart Bar
   Place: Theme > Assets > sticky-atc.js
   ============================================================ */

(function () {
  'use strict';

  const SCROLL_TRIGGER_SELECTOR = '#ProductSubmitButton, .product-form__submit, [name="add"]';

  const style = document.createElement('style');
  style.textContent = `
    @import url('https://fonts.googleapis.com/css2?family=Tenor+Sans&family=DM+Sans:wght@400;500&display=swap');

    #wc-sticky-atc {
      position: fixed;
      bottom: 0;
      left: 0;
      right: 0;
      z-index: 9999;
      background: #F7F4F0;
      border-top: 1px solid #E2DDD8;
      padding: 12px 20px 14px;
      display: flex;
      align-items: center;
      gap: 12px;
      transform: translateY(100%);
      transition: transform 0.35s cubic-bezier(0.22, 1, 0.36, 1);
      box-shadow: 0 -4px 24px rgba(28,28,26,0.08);
      font-family: 'DM Sans', sans-serif;
    }

    #wc-sticky-atc.wc-visible {
      transform: translateY(0);
    }

    #wc-sticky-atc .wc-product-title {
      font-family: 'Tenor Sans', serif;
      font-size: 13px;
      color: #1C1C1A;
      white-space: nowrap;
      overflow: hidden;
      text-overflow: ellipsis;
      flex-shrink: 1;
      min-width: 0;
      display: none;
    }

    #wc-sticky-atc .wc-divider {
      width: 1px;
      height: 32px;
      background: #E2DDD8;
      flex-shrink: 0;
      display: none;
    }

    #wc-sticky-atc .wc-select {
      appearance: none;
      -webkit-appearance: none;
      background: #fff url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='10' height='6' viewBox='0 0 10 6'%3E%3Cpath d='M1 1l4 4 4-4' stroke='%231C1C1A' stroke-width='1.5' fill='none' stroke-linecap='round'/%3E%3C/svg%3E") no-repeat right 10px center;
      border: 1px solid #E2DDD8;
      border-radius: 4px;
      padding: 7px 30px 7px 11px;
      font-family: 'DM Sans', sans-serif;
      font-size: 13px;
      color: #1C1C1A;
      cursor: pointer;
      min-width: 90px;
      flex-shrink: 0;
    }

    #wc-sticky-atc .wc-select:focus {
      outline: none;
      border-color: #1C1C1A;
    }

    #wc-sticky-atc .wc-add-btn {
      flex: 1;
      background: #111111;
      color: #F7F4F0;
      border: none;
      border-radius: 4px;
      padding: 11px 18px;
      font-family: 'DM Sans', sans-serif;
      font-size: 13px;
      font-weight: 500;
      letter-spacing: 0.04em;
      text-transform: uppercase;
      cursor: pointer;
      transition: background 0.2s, opacity 0.2s;
      white-space: nowrap;
    }

    #wc-sticky-atc .wc-add-btn:hover {
      background: #2a2a2a;
    }

    #wc-sticky-atc .wc-add-btn:disabled {
      opacity: 0.45;
      cursor: not-allowed;
      background: #111111;
    }

    #wc-sticky-atc .wc-add-btn.wc-adding {
      opacity: 0.6;
    }

    #wc-sticky-atc .wc-feedback {
      position: absolute;
      top: -36px;
      left: 50%;
      transform: translateX(-50%);
      background: #1C1C1A;
      color: #F7F4F0;
      font-size: 12px;
      font-family: 'DM Sans', sans-serif;
      padding: 6px 14px;
      border-radius: 20px;
      white-space: nowrap;
      opacity: 0;
      pointer-events: none;
      transition: opacity 0.2s;
    }

    #wc-sticky-atc .wc-feedback.wc-show {
      opacity: 1;
    }

    @media (min-width: 600px) {
      #wc-sticky-atc {
        padding: 14px 32px 16px;
        gap: 16px;
      }
      #wc-sticky-atc .wc-divider {
        display: block;
      }
    }

    @media (min-width: 1024px) {
      #wc-sticky-atc {
        padding: 14px calc((100vw - 1200px) / 2 + 32px) 16px;
      }
      #wc-sticky-atc .wc-product-title {
        display: block;
      }
    }
  `;
  document.head.appendChild(style);

  function init() {
    const product = window.__wcProduct;
    if (!product) return;

    const variants = product.variants || [];
    const options  = product.options  || [];

    const colorIdx = options.findIndex(o => /colou?r/i.test(o));
    const sizeIdx  = options.findIndex(o => /size/i.test(o));

    const colorValues = colorIdx >= 0
      ? [...new Set(variants.map(v => v[`option${colorIdx + 1}`]))]
      : [];
    const sizeValues = sizeIdx >= 0
      ? [...new Set(variants.map(v => v[`option${sizeIdx + 1}`]))]
      : [];

    let selectedColor = colorValues[0] || null;
    let selectedSize  = sizeValues[0]  || null;

    function getVariant() {
      return variants.find(v => {
        const colorMatch = colorIdx < 0 || v[`option${colorIdx + 1}`] === selectedColor;
        const sizeMatch  = sizeIdx  < 0 || v[`option${sizeIdx  + 1}`] === selectedSize;
        return colorMatch && sizeMatch;
      });
    }

    const bar = document.createElement('div');
    bar.id = 'wc-sticky-atc';
    bar.setAttribute('aria-label', 'Quick add to cart');

    const titleEl = document.createElement('span');
    titleEl.className = 'wc-product-title';
    titleEl.textContent = product.title;

    const divider = document.createElement('div');
    divider.className = 'wc-divider';

    // Color dropdown
    const colorSelect = document.createElement('select');
    colorSelect.className = 'wc-select';
    colorSelect.setAttribute('aria-label', 'Select color');
    colorValues.forEach(color => {
      const opt = document.createElement('option');
      opt.value = color;
      opt.textContent = color;
      colorSelect.appendChild(opt);
    });
    colorSelect.addEventListener('change', () => {
      selectedColor = colorSelect.value;
      syncNativeOption(options[colorIdx], selectedColor);
      updateState();
    });

    // Size dropdown
    const sizeSelect = document.createElement('select');
    sizeSelect.className = 'wc-select';
    sizeSelect.setAttribute('aria-label', 'Select size');
    sizeValues.forEach(size => {
      const opt = document.createElement('option');
      opt.value = size;
      opt.textContent = size;
      sizeSelect.appendChild(opt);
    });
    sizeSelect.addEventListener('change', () => {
      selectedSize = sizeSelect.value;
      syncNativeOption(options[sizeIdx], selectedSize);
      updateState();
    });

    const btn = document.createElement('button');
    btn.className = 'wc-add-btn';
    btn.textContent = 'Add to Cart';
    btn.addEventListener('click', addToCart);

    const feedback = document.createElement('span');
    feedback.className = 'wc-feedback';

    if (colorValues.length > 0) bar.appendChild(colorSelect);
    if (colorValues.length > 0 && sizeValues.length > 0) bar.appendChild(divider);
    if (sizeValues.length > 0) bar.appendChild(sizeSelect);
    bar.appendChild(titleEl);
    bar.appendChild(btn);
    bar.appendChild(feedback);
    document.body.appendChild(bar);

    updateState();

    const nativeBtn = document.querySelector(SCROLL_TRIGGER_SELECTOR);
    if (nativeBtn) {
      const observer = new IntersectionObserver(entries => {
        bar.classList.toggle('wc-visible', !entries[0].isIntersecting);
      }, { threshold: 0 });
      observer.observe(nativeBtn);
    }

    function updateState() {
      const variant = getVariant();
      const available = variant ? variant.available : false;
      btn.disabled = !available;
      btn.textContent = available ? 'Add to Cart' : 'Sold Out';
    }

    function addToCart() {
      const variant = getVariant();
      if (!variant || !variant.available) return;

      btn.classList.add('wc-adding');
      btn.disabled = true;
      btn.textContent = '...';

      fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
        body: JSON.stringify({ id: variant.id, quantity: 1 })
      })
      .then(r => r.json())
      .then(() => {
        showFeedback('Added to cart ✓');
        document.dispatchEvent(new CustomEvent('cart:refresh'));
        document.dispatchEvent(new CustomEvent('theme:cart:open'));
      })
      .catch(() => {
        showFeedback('Something went wrong');
      })
      .finally(() => {
        btn.classList.remove('wc-adding');
        updateState();
      });
    }

    function showFeedback(msg) {
      feedback.textContent = msg;
      feedback.classList.add('wc-show');
      setTimeout(() => feedback.classList.remove('wc-show'), 2200);
    }

    function syncNativeOption(optionName, value) {
      if (!optionName) return;
      const radio = document.querySelector(
        `input[type="radio"][name="${optionName}"][value="${value}"], input[type="radio"][data-value="${value}"]`
      );
      if (radio && !radio.checked) { radio.click(); return; }
      const sel = document.querySelector(`select[data-option="${optionName}"], select[name="${optionName}"]`);
      if (sel) {
        sel.value = value;
        sel.dispatchEvent(new Event('change', { bubbles: true }));
      }
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

})();